import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiLogOut,
  FiMenu,
  FiChevronDown,
  FiSearch,
  FiArrowLeft,
  FiBell,
  FiSettings,
} from "react-icons/fi";
import { GoPackage } from "react-icons/go";
import { FaCrown, FaGavel, FaUser } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { AiFillStar, AiOutlinePhone } from "react-icons/ai";
import { GiDiamondTrophy } from "react-icons/gi";
import { motion, AnimatePresence } from "framer-motion";
import { RiCoinsLine } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
import {
  MdOutlineEditCalendar,
  MdPersonAdd,
  MdPhotoLibrary,
} from "react-icons/md";
import { sendApiRequest } from "../../utils";
import { MdArticle } from "react-icons/md";
import { BiLineChart } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { setValue } from "../../features/UserInfo/userSlice";

const AdminLayout = ({setIsRefresh}) => {
  const userData = useSelector(state => state.user_info[0]?.user);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [notifications, setNotifications] = useState(3); // Mock notification count
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();


  useEffect(()=>{
    if(!location.pathname.startsWith("/admin/packages/view-receipt")){
      localStorage.removeItem('paymentReceiptFromOnce')
    }
  },[location])



  const menuItems = [
    // 1. Dashboard
    {
      path: "/admin",
      icon: <FiHome className="w-5 h-5" />,
      title: "Dashboard",
    },

    // 2. Core Management
    {
      path: "/plot",
      icon: <BiLineChart className="w-5 h-5" />,
      title: "Plots",
      submenu: [
        { path: "/admin/plot/add", title: "Add Plot" },
        { path: "/admin/plot/list", title: "Show Plot" },
      ],
    },
    {
      path: "/plan",
      icon: <MdOutlineEditCalendar className="w-5 h-5" />,
      title: "Plans",
      submenu: [
        { path: "/admin/plan/add", title: "Add Plan" },
        { path: "/admin/plan/list", title: "Plan List" },
      ],
    },

    // 3. Media & Content
    {
      path: "/gallery",
      icon: <MdPhotoLibrary className="w-5 h-5" />,
      title: "Gallery",
      submenu: [
        { path: "/admin/gallery/add", title: "Add Gallery" },
        { path: "/admin/gallery/list", title: "Show Gallery" },
      ],
    },
    {
      path: "/news",
      icon: <MdArticle className="w-5 h-5" />,
      title: "News",
      submenu: [
        { path: "/admin/news/add", title: "Add News" },
        { path: "/admin/news/list", title: "Show News" },
      ],
    },

    // 4. Financial Management
    {
      path: "/withdrawal-requests",
      icon: <RiCoinsLine className="w-5 h-5" />,
      title: "Withdrawal Requests",
      submenu: [
        { path: "/admin/withdrawal-requests", title: "Manage Requests" },
      ],
    },

    // 4. Legal & Support
    {
      path: "/legal",
      icon: <FaGavel className="w-5 h-5" />,
      title: "Legal",
      submenu: [
        { path: "/admin/legal/add", title: "Add Legal Document" },
        { path: "/admin/legal/list", title: "Show Legal Documents" },
      ],
    },
    {
      path: "/contact",
      icon: <AiOutlinePhone className="w-5 h-5" />,
      title: "Contact",
      submenu: [{ path: "/admin/contact/list", title: "Show Contact Details" }],
    },

    // 5. Admin & Team
    {
      path: "/team-member",
      icon: <MdPersonAdd className="w-5 h-5" />,
      title: "Team Members",
      submenu: [
        { path: "/admin/team-member/add", title: "Add Member" },
        { path: "/admin/team-member/list", title: "Member List" },
      ],
    },
    {
      path: "/packages",
      icon: <GoPackage className="w-5 h-5" />,
      title: "Add New Packages",
      submenu: [
        { path: "/admin/packages/add", title: "Add New Package" },
        { path: "/admin/packages/show", title: "Show All Packages" },
        // { path: "/admin/packages/approval", title: "Package Approval Requests" },
        // { path: "/admin/packages/generate-receipt", title: "Generate Receipt" },
        { path: "/admin/packages/generate-receipt-manually", title: "Generate Manually Receipt" },
        { path: "/admin/packages/view-receipt", title: "View Receipt" },
        { path: "/admin/packages/month-wise-excel-report", title: "Month-Wise Excel Report" },
      ],
    },
    {
      path: "/users",
      icon: <FaUser className="w-5 h-5" />,
      title: "All Users",
      submenu: [
        { path: "/admin/customer/list", title: "Customer List" },
        { path: "/admin/partner/list", title: "Partner List" },
        { path: "/admin/admin-network-explorer", title: "Admin Network Explorer" },
        // { path: "/admin/packages/approval/request", title: "Package Approval Request" },
      ],
    },
    {
      path: "/kyc",
      icon: <MdOutlinePendingActions className="w-5 h-5" />,
      title: "KYC Approval Requests",
      submenu: [
        { path: "/admin/kyc-approval/list", title: "All KYC Approval List" },
      ],
    },
    {
      path: "/closing-report",
      icon: <TbReportAnalytics className="w-5 h-5" />,
      title: "Closing Report",
      submenu: [
        { path: "/admin/closing-reports", title: "Check Closing Reports" },
      ],
    },
  ];

  useEffect(() => {
    if (!Array.isArray(menuItems)) return;

    const activeIndex = menuItems.findIndex(
      (item) =>
        item.submenu &&
        item.submenu.some((sub) => location.pathname === sub.path)
    );

    if (activeIndex !== -1) {
      setActiveSubmenu(activeIndex);
    }
  }, [location.pathname]);

  const toggleSubmenu = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  const handleBack = () => {
    navigate(-1); // Go back to previous page
  };
  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    setIsRefresh("adminlogg");
    dispatch(setValue("Logout"));
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar Backdrop (Mobile) */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSidebarOpen(false)}
            className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          />
        )}
      </AnimatePresence>

      {/* Sidebar */}
      <motion.div
        initial={{ x: -300 }}
        animate={{ x: sidebarOpen ? 0 : -300 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className={`fixed inset-y-0 left-0 z-30 w-72 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white shadow-2xl transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 flex flex-col h-full`}
        style={{ height: "100vh" }}
      >
        <div className="flex flex-col h-full">
          {/* Logo Section */}


          {/* Profile Section */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="p-6 border-b border-blue-700/30"
          >
            <motion.div
              className="flex items-center space-x-4"
              whileHover={{ y: -2 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              <div className="relative group">
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="relative cursor-pointer"
                >
                  <img
                    src="/assets/profile-placeholder.jpg"
                    alt="Profile"
                    className="w-16 h-16 rounded-full ring-2 ring-sky-400 p-[2px] bg-gradient-to-r from-sky-500 to-blue-500 shadow-lg shadow-blue-900/50"
                  />
                  <div className="absolute -top-1 -right-1 bg-emerald-400 text-xs font-bold px-1.5 py-0.5 rounded-full flex items-center justify-center text-gray-900 shadow-md">
                    <FaCrown className="mr-0.5 w-3 h-3" /> Admin
                  </div>
                </motion.div>
                <div className="absolute bottom-0 right-0 w-4 h-4 bg-emerald-500 rounded-full border-2 border-blue-800 animate-pulse shadow-md"></div>
              </div>

              <div className="flex-1">
                <motion.div
                  whileHover={{ x: 2 }}
                  className="flex items-center space-x-2"
                >
                  <h3 className="font-semibold text-lg text-white">{userData?.fullName}</h3>
                  <AiFillStar className="w-4 h-4 text-amber-400" />
                </motion.div>
                <p className="text-sm text-blue-100">ID: {userData?.sponsorCode}</p>
              </div>
            </motion.div>

            {/* <div className="grid grid-cols-2 gap-3 mt-4">
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="bg-gradient-to-r from-sky-500/10 to-blue-500/10 p-3 rounded-xl border border-blue-600/20 shadow-inner"
              >
                <p className="text-sm text-blue-100">Total Earnings</p>
                <p className="text-lg font-semibold text-white">₹12,450</p>
                <div className="mt-1 h-1 w-full bg-blue-900/30 rounded-full overflow-hidden">
                  <div className="h-full w-3/4 bg-gradient-to-r from-sky-400 to-blue-500 rounded-full"></div>
                </div>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="bg-gradient-to-r from-emerald-500/10 to-green-500/10 p-3 rounded-xl border border-emerald-600/20 shadow-inner"
              >
                <p className="text-sm text-blue-100">Team Members</p>
                <p className="text-lg font-semibold text-white">45</p>
                <div className="mt-1 h-1 w-full bg-emerald-900/30 rounded-full overflow-hidden">
                  <div className="h-full w-2/3 bg-gradient-to-r from-emerald-400 to-green-500 rounded-full"></div>
                </div>
              </motion.div>
            </div> */}
          </motion.div>

          {/* Navigation Menu */}
          <nav
            className="flex-1 px-4 pt-6 pb-4 overflow-y-auto"
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {menuItems.map((item, index) => (
              <motion.div
                key={item.path}
                className="mb-2"
                whileHover={{ x: 4 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <Link
                  to={item.path}
                  onClick={(e) => {
                    if (item.submenu) {
                      e.preventDefault();
                      toggleSubmenu(index);
                    }
                  }}
                  className={`flex items-center justify-between px-4 py-3 transition-all duration-200 rounded-xl group relative overflow-hidden ${location.pathname === item.path ||
                      (item.submenu &&
                        item.submenu.some(
                          (sub) => location.pathname === sub.path
                        ))
                      ? "bg-gradient-to-r from-sky-600 to-blue-600 text-white shadow-lg shadow-blue-500/30"
                      : "text-blue-100 hover:bg-blue-700/30 hover:text-white"
                    }`}
                >
                  <div className="flex items-center relative z-10">
                    <div
                      className={`p-1.5 rounded-lg transition-all duration-200 ${location.pathname === item.path ||
                          (item.submenu &&
                            item.submenu.some(
                              (sub) => location.pathname === sub.path
                            ))
                          ? "bg-white/20"
                          : "group-hover:bg-white/10"
                        }`}
                    >
                      {item.icon}
                    </div>
                    <span className="ml-3 font-medium">{item.title}</span>
                  </div>
                  {item.submenu && (
                    <FiChevronDown
                      className={`w-4 h-4 transition-transform duration-300 ${activeSubmenu === index ? "transform rotate-180" : ""
                        }`}
                    />
                  )}
                  {/* Hover effect background */}
                  <div className="absolute inset-0 bg-gradient-to-r from-sky-500/10 to-blue-500/10 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
                </Link>

                {/* Submenu with improved animation */}
                {item.submenu && activeSubmenu === index && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    className="pl-12 mt-1 space-y-1"
                  >
                    {item.submenu.map((subItem) => (
                      <motion.div
                        key={subItem.path}
                        whileHover={{ x: 4 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 10,
                        }}
                      >
                        <Link
                          to={subItem.path}
                          className={`block px-3 py-2 text-sm rounded-lg transition-all duration-200 ${location.pathname === subItem.path
                              ? "bg-blue-800/40 text-blue-200 shadow-sm shadow-blue-900/20"
                              : "text-blue-200 hover:bg-blue-700/30 hover:text-white"
                            }`}
                        >
                          {subItem.title}
                        </Link>
                      </motion.div>
                    ))}
                  </motion.div>
                )}
              </motion.div>
            ))}
          </nav>

          {/* Sidebar Footer */}
          <div className="p-4 border-t border-blue-700/30 mt-auto">
            <button onClick={handleLogout} className="flex items-center w-full px-4 py-3 text-blue-100 hover:bg-red-500/10 hover:text-red-400 rounded-xl transition-colors">
              <FiLogOut className="w-5 h-5" />
              <span className="ml-3 font-medium">Logout</span>
            </button>
          </div>
        </div>
      </motion.div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header */}
        <header className="fixed top-0 right-0 left-0 lg:left-72 z-20 flex items-center justify-between h-20 px-6 bg-white dark:bg-gray-800 shadow-sm backdrop-blur-sm bg-white/90 dark:bg-gray-800/90 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white mr-4"
            >
              <FiMenu className="w-6 h-6" />
            </button>

            {/* Back Button - Only show when not on dashboard home */}
            {!location.pathname.match(/^\/dashboard$/) && (
              <button
                onClick={handleBack}
                className="flex items-center text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white mr-4"
              >
                <FiArrowLeft className="w-5 h-5 mr-1" />
                <span className="text-sm">Back</span>
              </button>
            )}

            {/* Search Bar */}
            {/* <motion.div
              whileHover={{ scale: 1.01 }}
              className="hidden md:block relative"
            >
              <input
                type="text"
                placeholder="Search..."
                className="w-64 px-4 py-2 rounded-full bg-gray-100 dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-all duration-200 pl-10"
              />
              <div className="absolute left-3 top-2.5 text-gray-400 dark:text-gray-500">
                <FiSearch className="w-4 h-4" />
              </div>
            </motion.div> */}
          </div>

          <div className="flex items-center space-x-6">
            {/* Quick Stats */}
            {/* <div className="hidden lg:flex items-center space-x-4">
              <div className="flex items-center space-x-2 bg-sky-100 dark:bg-sky-900/30 px-3 py-1.5 rounded-full shadow-sm">
                <GiDiamondTrophy className="text-sky-600 dark:text-sky-400" />
                <span className="text-sm font-medium text-sky-600 dark:text-sky-400">
                  Rank: Admin
                </span>
              </div>
              <div className="flex items-center space-x-2 bg-emerald-100 dark:bg-emerald-900/30 px-3 py-1.5 rounded-full shadow-sm">
                <RiCoinsLine className="text-emerald-600 dark:text-emerald-400" />
                <span className="text-sm font-medium text-emerald-600 dark:text-emerald-400">
                  +₹10245 Today
                </span>
              </div>
            </div> */}

            {/* Notification and Settings */}

          </div>
        </header>

        {/* Main Content Area */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900/20 p-6 mt-20 transition-colors duration-300">
          <div className="max-w-7xl mx-auto">
            {/* Content Card */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 mb-6 transition-all duration-300 hover:shadow-lg border border-gray-100 dark:border-gray-700"
            >
              <Outlet />
            </motion.div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
